// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Maybe_Trans from "../Control.Monad.Maybe.Trans/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Effect from "../Effect/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var traverse_ = /* #__PURE__ */ Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe);
var map1 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorEvent);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var composeKleisli = /* #__PURE__ */ Control_Bind.composeKleisli(Effect.bindEffect);
var apply = /* #__PURE__ */ Control_Apply.apply(Data_Maybe.applyMaybe);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var WeakDynamic = function (x) {
    return x;
};
var weaken = /* #__PURE__ */ (function () {
    var $63 = map(Data_Maybe.Just.create);
    return function ($64) {
        return WeakDynamic(Control_Monad_Maybe_Trans.MaybeT($63($64)));
    };
})();
var unWeakDynamic = function (v) {
    return v;
};
var tagWeakDyn = function (wdyn) {
    return function (event) {
        return Specular_FRP_Base.filterMapEvent(identity)(Specular_FRP_Base.attachDynWith(function (a) {
            return function (_b) {
                return a;
            };
        })(unWeakDynamic(wdyn))(event));
    };
};
var switchWeakDyn = function (v) {
    return Specular_FRP_Base["switch"](map(Data_Maybe.fromMaybe(Specular_FRP_Base.never))(v));
};
var subscribeWeakDyn_ = function (dictMonadFRP) {
    var subscribeDyn_ = Specular_FRP_Base.subscribeDyn_(dictMonadFRP);
    return function (handler) {
        return function (v) {
            return subscribeDyn_(traverse_(handler))(v);
        };
    };
};
var monadWeakDynamic = /* #__PURE__ */ Control_Monad_Maybe_Trans.monadMaybeT(Specular_FRP_Base.monadDynamic);
var mkWeakDynamic = function ($65) {
    return WeakDynamic(Control_Monad_Maybe_Trans.MaybeT($65));
};
var liftEqMaybe = function (eq) {
    return function (v) {
        return function (v1) {
            if (v instanceof Data_Maybe.Just && v1 instanceof Data_Maybe.Just) {
                return eq(v.value0)(v1.value0);
            };
            if (v instanceof Data_Maybe.Nothing && v1 instanceof Data_Maybe.Nothing) {
                return true;
            };
            return false;
        };
    };
};
var uniqWeakDynBy = function (dictMonadFRP) {
    var map3 = Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0());
    var uniqDynBy = Specular_FRP_Base.uniqDynBy(dictMonadFRP);
    return function (eq) {
        return function (wdyn) {
            return map3(mkWeakDynamic)(uniqDynBy(liftEqMaybe(eq))(unWeakDynamic(wdyn)));
        };
    };
};
var holdWeakDyn = function (dictMonadFRP) {
    var map3 = Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0());
    var holdDyn = Specular_FRP_Base.holdDyn(dictMonadFRP);
    return function (change) {
        return map3(function ($66) {
            return WeakDynamic(Control_Monad_Maybe_Trans.MaybeT($66));
        })(holdDyn(Data_Maybe.Nothing.value)(map1(Data_Maybe.Just.create)(change)));
    };
};
var subscribeWeakDyn = function (dictMonadFRP) {
    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var newEvent = Specular_FRP_Base.newEvent(dictMonadFRP.MonadEffect0());
    var holdWeakDyn1 = holdWeakDyn(dictMonadFRP);
    var discard1 = discard(Bind1);
    var subscribeWeakDyn_1 = subscribeWeakDyn_(dictMonadFRP);
    var pure1 = Control_Applicative.pure(Monad0.Applicative0());
    return function (handler) {
        return function (wdyn) {
            return bind(newEvent)(function (v) {
                return bind(holdWeakDyn1(v.event))(function (result) {
                    return discard1(subscribeWeakDyn_1(composeKleisli(handler)(v.fire))(wdyn))(function () {
                        return pure1(result);
                    });
                });
            });
        };
    };
};
var functorWeakDynamic = /* #__PURE__ */ Control_Monad_Maybe_Trans.functorMaybeT(Specular_FRP_Base.functorDynamic);
var changedW = /* #__PURE__ */ (function () {
    var $67 = Specular_FRP_Base.filterMapEvent(identity);
    return function ($68) {
        return $67(Specular_FRP_Base.changed(unWeakDynamic($68)));
    };
})();
var bindWeakDynamic = /* #__PURE__ */ Control_Monad_Maybe_Trans.bindMaybeT(Specular_FRP_Base.monadDynamic);
var attachWeakDynWith = function (f) {
    return function (wdyn) {
        return function (event) {
            return Specular_FRP_Base.filterMapEvent(identity)(Specular_FRP_Base.attachDynWith(function (a) {
                return function (b) {
                    return apply(map2(f)(a))(pure(b));
                };
            })(unWeakDynamic(wdyn))(event));
        };
    };
};
var applyWeakDynamic = /* #__PURE__ */ Control_Monad_Maybe_Trans.applyMaybeT(Specular_FRP_Base.monadDynamic);
var applicativeWeakDynamic = /* #__PURE__ */ Control_Monad_Maybe_Trans.applicativeMaybeT(Specular_FRP_Base.monadDynamic);
export {
    unWeakDynamic,
    changedW,
    weaken,
    holdWeakDyn,
    switchWeakDyn,
    subscribeWeakDyn,
    subscribeWeakDyn_,
    attachWeakDynWith,
    tagWeakDyn,
    uniqWeakDynBy,
    functorWeakDynamic,
    applyWeakDynamic,
    applicativeWeakDynamic,
    bindWeakDynamic,
    monadWeakDynamic
};
